export default "__VITE_ASSET__69cf1b48__"